module.exports = __webpack_public_path__ + "img/logo.0b01cc10.png";